import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** ******************************************************************************
 * Copyright (c) 2022 Precies. Software and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 * ****************************************************************************** */
import { useState } from 'react';
import { Box, Button, Menu, MenuItem, Typography, Link } from '@mui/material';
import { getTargetPlatformDisplayName } from '../../utils';
export const ExtensionDetailDownloadsMenu = props => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center' }, children: [_jsx(Button, { variant: 'contained', color: 'secondary', sx: { mt: 2 }, title: 'Download', "aria-label": 'Download', onClick: handleClick, children: "Download" }), _jsx(Menu, { open: Boolean(anchorEl), anchorEl: anchorEl, transformOrigin: { vertical: 'top', horizontal: 'left' }, sx: { mt: 1 }, onClose: handleClose, children: Object.keys(props.downloads).map(targetPlatform => {
                    const downloadLink = props.downloads[targetPlatform];
                    return (_jsx(MenuItem, { component: Link, href: downloadLink, onClick: handleClose, sx: { textDecoration: 'none' }, children: _jsx(Typography, { variant: 'body2', color: 'text.primary', children: getTargetPlatformDisplayName(targetPlatform) }) }, targetPlatform));
                }) })] }));
};
//# sourceMappingURL=extension-detail-downloads-menu.js.map